<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="599px">
      <v-card>
        <v-toolbar elevation="0">
          <v-toolbar-title class="pl-3 py-2 text--subtitle">
            <b style="font-weight: 500; font-size: 1.25rem"
              >{{ $t('message.pages.modalCreateNewLiveTrial.title') }}
            </b>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="px-7 py-0">
          <v-row no-gutters>
            <v-col cols="12">
              <v-card-text class="pa-0" v-if="totalUsers">
                {{ $t('message.pages.modalMaxUsers.message1') }}
                <b>
                  {{ totalUsers }}
                  {{
                    totalUsers === 1
                      ? $t('message.pages.modalMaxUsers.message2sing')
                      : $t('message.pages.modalMaxUsers.message2')
                  }}
                  {{
                    addonUsers
                      ? addonUsers === 1
                        ? '(' +
                          addonUsers +
                          $t('message.pages.modalMaxUsers.message3sing')
                        : '(' +
                          addonUsers +
                          $t('message.pages.modalMaxUsers.message3')
                      : ''
                  }}
                </b>
                <br />
                {{
                  totalUsers + addonUsers === 1
                    ? $t('message.pages.modalMaxUsers.message4sing')
                    : $t('message.pages.modalMaxUsers.message4')
                }}
                <br />
                <!-- {{ $t('message.pages.modalMaxUsers.message6') }}
                <a
                  :href="helpLink"
                  target="_blank"
                  style="text-decoration: none"
                >
                  {{ $t('message.pages.modalMaxUsers.message7') }}
                </a> -->
              </v-card-text>
              <v-card-text class="pa-0" v-else>
                <div class="mb-6 font-weight-regular pr-3">
                  <span style="font-size: 1.125rem">
                    {{ $t('message.pages.modalCreateNewLiveTrial.subtitle') }}
                  </span>
                </div>
                <span class="helpfullText">
                  {{ $t('message.pages.modalCreateNewLiveTrial.helpfull') }}
                  <a
                    style="text-decoration: none"
                    target="_blank"
                    :href="helpLink"
                  >
                    {{
                      $t('message.pages.modalCreateNewLiveTrial.helpfullLink')
                    }}
                  </a>
                  <v-icon size="14" color="primary">mdi-open-in-new</v-icon>
                </span>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider class="my-6 mx-7" />
        <v-card-actions class="px-8 mb-6">
          <v-spacer></v-spacer>
          <v-btn
            class="mr-2 px-4 text-capitalize"
            outlined
            color="primary"
            @click="handleClose"
          >
            {{ $t('message.cancel') }}
          </v-btn>
          <v-btn
            flat
            class="text-capitalize"
            color="primary"
            @click="handleCart"
          >
            {{ $t('message.actions.active') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
import linkHelper from '@/utils/linkHelper.mixin.js'

export default {
  name: 'WarningTrial',
  mixins: [linkHelper],
  components: {},
  data: () => ({
    open: false,
    totalUsers: null,
    addonUsers: null,
  }),
  computed: {
    ...mapState({
      userPlanInfo: (state) => state.user.userPlanInfo,
    }),
    helpLink() {
      return this.getLiveLink()
    },
  },
  mounted() {
    this.$root.$on('modalWarningTrial', () => {
      this.open = true
      const addonUsers = this.userPlanInfo.addons?.slot_user
        ? this.userPlanInfo.addons?.slot_user[0]?.quantity
        : 0
      const planUsers =
        Number(this.userPlanInfo.subscription?.metadata?.users) ?? 0
      const amountOfUsers = addonUsers + planUsers
      this.addonUsers = addonUsers
      this.totalUsers = amountOfUsers
    })
  },
  beforeDestroy() {
    this.$root.$off('modalMaxUsers')
  },
  methods: {
    ...mapMutations('user', ['UPDATE_ONLY_CUSTOMIZING']),
    handleClose() {
      this.open = false
    },
    handleCart() {
      this.handleClose()
      this.UPDATE_ONLY_CUSTOMIZING(true)
      this.$router.push({ name: 'Cart' })
    },
    handleEvent(event) {
      const e = event
      if (e.key) {
        e.key === 'Escape' && this.handleClose()
      }
      return
    },
    handleTalkToUs() {},
    handleChat() {
      this.$crisp.push(['do', 'chat:show'])
      this.$crisp.push(['do', 'chat:open'])
    },
  },
}
</script>

<style lang="scss" scoped>
.notice-img {
  height: 270px;
  margin: 48px 0px;
}

.helpfullText {
  font-size: 1rem;
}

.text--subtitle {
  color: #1e2a77;
}
.bg-dark {
  .text--subtitle {
    color: #fff;
  }
}

@media only screen and (max-height: 680px) {
  .notice-img {
    height: 200px !important;
    margin: 12px 0px;
  }
}

@media only screen and (max-height: 535px) {
  .notice-img {
    margin: 0px;
  }
}
</style>
